/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

"use strict";

import React from "react";

import styled, {css} from "styled-components";

import PropTypes from "prop-types";

import {WealthyEnv} from "helpers";

const propTypes = {
  onClickHandler: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool
};

const backIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/back-icon.svg`;

const BackIcon = ({
  onClickHandler,
  showBackButton
}) => {
  return (
    <Image
      alt="back-icon"
      loading="lazy"
      showBackButton={showBackButton}
      src={backIcon}
      onClick={onClickHandler}
    />
  );
};

const Image = styled.img`
${props =>
    props.showBackButton === false &&
    css`
      visibility: hidden;
    `}

  :hover {
    cursor: pointer;
  }
`;

BackIcon.propTypes = propTypes;

export default BackIcon;
